import React from 'react'
import Appbar from '../components/bars/Appbar'
import Tabbar from '../components/bars/Tabbar'

function Teams() {
  return (
    <div className='mw'>
      <div className="screen">
        <Appbar show='flex' />
        <h1 className="title">Teams</h1>
        <Tabbar show='flex' />
      </div>
    </div>
  )
}

export {Teams}
